import styled from '@emotion/styled'

import { comparatorStyles } from '../../constants'
import { Div } from '../Div'

export const ComparatorOperation = styled(Div)(comparatorStyles)
